<script>
export default {
  name: "ReleaseDialog",
  props: {
    release: {
      visible: Boolean,
      formData: {}
    },
    id: String
  },
  data() {
    return {
      isFullScreen: false,
      userList: [],
      checked: true,
      allChecked: false
    }
  },
  methods: {
    init() {
      this.request.get('/rm-bresuser/queryResUserList').then(
          (res) => {
            if (res.ok) {
              this.userList = res.data;
            } else {
              this.$message.error(res.error.message);
            }
          }
      );
    },
    releaseHandle() {
      this.request.post('/rm-tyjxx/sendSms', this.release.formData).then(
          (res) => {
            if (res.ok) {
              this.$message.success("发布成功！");
              this.release.visible = false;
            } else {
              this.$message.error(res.error.message);
            }
          }
      )
    },
    handleClose() {
      this.allChecked = false;
      this.release.formData.useridList = [];
    },
    allChange(val) {
      this.release.formData.useridList = val ? this.userList.map(_ => _.k) : [];
    }
  },
  mounted() {
    this.init();
  },

}
</script>

<template>
  <el-dialog
      v-dialogDrag
      :closeOnClickModal="false"
      :visible.sync="release.visible"
      class="abow_dialog"
      top="5vh"
      width="40vw"
      :fullscreen="isFullScreen"
      @close="handleClose">
    <div slot="title" class="header-title">
      <div class="dgTitle">预警发布</div>
      <el-image class="dgImg2" :src="require('../../../assets/icons/dg-gb.png')" @click="release.visible = false"></el-image>
    </div>
    <el-row :gutter="20">
      <el-col :span="12">
        <el-card>
          <div slot="header" class="clearfix">
            <el-checkbox v-model="allChecked" @change="allChange">请选择人员</el-checkbox>
          </div>
          <el-checkbox-group v-model="release.formData.useridList">
            <el-checkbox
                v-for="(item,index) in userList"
                style="display: block; margin: 10px;"
                :key="index"
                :label="item.k">
              {{item.v}} <span v-if="release.userList.find(_ => _.userName === item.v)" style="color: #4CA93B;">（已发）</span>
            </el-checkbox>
          </el-checkbox-group>
        </el-card>
      </el-col>
      <el-col :span="12">
        <el-card>
          <div slot="header" class="clearfix">
            <span>已发布详情</span>
          </div>
          <el-checkbox
              v-model="checked"
              style="display: block; margin: 10px;"
              v-for="(item,index) in release.userList"
              disabled
              :key="index">
            {{item.userName}} ({{item.fssj}})
          </el-checkbox>
        </el-card>
      </el-col>
    </el-row>
    <span slot="footer" class="dialog-footer">
       <el-button
           @click="release.visible = false"
           class="dgClose">
         取 消
       </el-button>
      <el-button
          slot="reference"
          type="primary"
          @click="releaseHandle"
          class="dgSave">发 布
          </el-button>
    </span>
  </el-dialog>
</template>

<style scoped>
.dgClose{
  width: 8vh;
  height: 3vh;
  font-family: PingFang SC;
  font-size: 1.2vh;
  font-weight: normal;
  font-stretch: normal;
  line-height: 3vh;
  letter-spacing: 0vh;
  color: #0066ff;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border: solid 1px #53abfd;
  border-radius: 2px;
}
.dgSave{
  width: 8vh;
  height: 3vh;
  background-color: #53abfd;
  border-radius: 0vh;
  font-family: PingFang SC;
  font-size: 1.2vh;
  font-weight: normal;
  font-stretch: normal;
  line-height: 3vh;
  letter-spacing: 0vh;
  color: #ffffff;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-radius: 2px;
}

.dgImg2{
  position: absolute;
  right: 2vh;
  top:1.5vh;
  width: 3vh;
  height: 3vh;
  line-height: 6vh;
  display: inline-block;
  vertical-align: middle;
  cursor: pointer;
}

.dgTitle{
  margin-left: 2vh;
  font-family: PingFang SC;
  font-size: 1.6vh;
  font-weight: normal;
  font-stretch: normal;
  letter-spacing: 0vh;
  color: #323232;
  line-height: 6vh;
  display: inline-block;
  vertical-align: middle;
}
.abow_dialog {
  display: flex;
  justify-content: center;
  align-items: Center;
  overflow: hidden;
}

::v-deep .el-dialog {
  margin: 0 auto;
  overflow: hidden;
}

::v-deep .el-dialog__header {
  height: 6vh;
  line-height: 6vh;
  padding: 0;
  /*background: linear-gradient(to bottom, #00A4B2, #2785D8);*/
  background-color: #f9f9ff;
  position: relative;
}

::v-deep .el-dialog__headerbtn .el-dialog__close {
  color: #fff;
}

::v-deep .el-dialog__headerbtn {
  position: absolute;
  top: 0px;
  right: 10px;
  height: 5vh;
  line-height: 5vh;
}

::v-deep .el-dialog__body {
  padding: 10px 20px 0px 20px;
  color: #606266;
  font-size: 14px;
  word-break: break-all;
  position: absolute;
  left: 0;
  top: 6vh;
  bottom: 70px;
  right: 0;
  overflow: auto;
}

::v-deep .dialog-footer {
  position: absolute;
  bottom: 0;
  left: 0;
  background-color: #fff;
  width: 100%;
  height: 70px;
  z-index: 10;
  display: flex;
  justify-content: flex-end;
  align-items: Center;
  box-sizing: border-box;
  padding-right: 20px;
}

::v-deep .el-dialog {
  height: 50%;
}

::v-deep .el-card__body {
  height: 200px;
  overflow-y: auto;
}
</style>